module.exports = __webpack_public_path__ + "static/img/btn_3.ae56836b.png";